import React from 'react';
import { StyleSheet, View } from 'react-native';
import type { CardProps, CardVariant } from '../types';
import { ACCENTS } from '../theme/accents';
import { colors, radius, shadow, spacing } from '../theme/tokens';

const BACKGROUNDS: Record<CardVariant, string> = {
  default: colors.white,
  feature: colors.white,
  dark: colors.ink,
};

export function Card({ children, variant = 'default', emphasis = false, accent, style, testID }: CardProps) {
  // Mise en avant : bordure vive + fond doux de l'accent (élément principal, ex. CV « Principal »).
  const highlight = emphasis && accent ? ACCENTS[accent] : null;

  return (
    <View
      testID={testID}
      style={[
        styles.base,
        {
          backgroundColor: highlight ? highlight.soft : BACKGROUNDS[variant],
          borderRadius: variant === 'feature' ? radius.xl : radius.lg,
        },
        highlight ? { borderWidth: 1.5, borderColor: highlight.vivid } : null,
        // En dernier : l'appelant peut compléter, jamais être écrasé par le composant.
        style,
      ]}
    >
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  base: {
    padding: spacing.lg,
    ...shadow.card,
  },
});
